import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {ArrUtil, Util} from 'yougile-util'
import {DataObjectId, Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {Dialog} from '@components/common/base/dialog/dialog'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {cn} from '@containers/html-utils'
import {ChatUtils} from '@extensions/chat-utils'
import {Task} from '@extensions/task'
import {
  MultiActionsWithTasksStore,
  useMultiActionsWithTasksStore
} from '../multi-actions-with-tasks-store'

export const DeleteTasksPopup = observer(() => {
  const [state, store] = useMultiActionsWithTasksStore()
  if (!state.deletePopup) {
    return null
  }
  const box = Sync.getCurrentSandbox()
  const bem = Util.bemFrom('stats-reports-data-field')

  const tasks = ArrUtil.filterNil([...state.tasksIds].map(t => box.getHub(t)))

  return (
    <Dialog
      close={() => store.setDeletePopup(false)}
      submit={() => store.performAction()}
      title={Lang.msg.multiActionsWithTasks.deleteSelectedTasks(
        state.tasksIds.size
      )}
      width={600}
      primaryBtnText={Lang.msg.multiActionsWithTasks.yesDelete}
      isDelete
    >
      <WithPerfectScrollbar className={'max-h-512 py-8'}>
        {tasks.map((t, index) => {
          const stage = Task.getGTDStage(t)

          const completeTime =
            stage === 'done'
              ? Math.max(Task.getGTDLastChangeTime(t) || 0, t.timestamp)
              : undefined

          return (
            <div
              key={index}
              className={cn(
                'flex items-center text-secondary py-4 pr-8',
                bem('title', {
                  complete: !!completeTime,
                  uncomplete: !completeTime
                }),
                index % 2 !== 0 && 'bg-background-secondary'
              )}
              onClick={titleClick(t.id, store)}
            >
              {t.title}
            </div>
          )
        })}
      </WithPerfectScrollbar>
    </Dialog>
  )
})

const titleClick =
  (id: DataObjectId, store: MultiActionsWithTasksStore) => () => {
    const box = Sync.getCurrentSandbox()
    const hub = box.get(id) as Hub
    if (hub) {
      store.setDeletePopup(false)

      ChatUtils.toggleChat(hub)
    }
  }
